import React from 'react';
import { AlertTriangle } from 'lucide-react';

const TechnologyProblem = () => {
  const frictions = [
    'Complex products change constantly',
    'Partner readiness varies wildly',
    'Enablement teams can\'t keep up',
    'Training completion doesn\'t equal capability',
    'Support and success teams absorb the fallout'
  ];

  return (
    <section className="py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
            But Growth Creates Friction
          </h2>
        </div>

        <div className="max-w-3xl mx-auto mb-12">
          <div className="grid gap-4">
            {frictions.map((friction, index) => (
              <div
                key={index}
                className="flex items-start gap-4 p-6 rounded-xl bg-gradient-to-br from-red-900/20 to-orange-900/20 border border-red-500/30"
              >
                <AlertTriangle className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" />
                <p className="text-lg text-gray-300">{friction}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="max-w-4xl mx-auto text-center space-y-6">
          <p className="text-xl text-gray-400 italic">
            Static training wasn't built for ecosystems this dynamic.
          </p>
        </div>
      </div>
    </section>
  );
};

export default TechnologyProblem;
